import 'simplebar/src/simplebar.css';
import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import {QueryClient,QueryClientProvider } from '@tanstack/react-query';
import store from './redux/store';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import 'leaflet/dist/leaflet.css';

// Create a root.
const container = document.getElementById('root');
const root = createRoot(container); // ← use createRoot
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// Optional: enable service worker (you can register() instead of unregister())
serviceWorker.unregister();

// Measure performance (optional)
reportWebVitals();
